module.exports = __webpack_public_path__ + "static/media/feather-alt.e931ffd6.svg";